import React from 'react';
import cx from 'classnames';
import { formatLocal } from '@hobs/utils/formatWithTimeZone';
import { DATETIME_FORMAT } from '@hobs/utils/constants';
import { messageShape } from './propTypes';
import { Icon as BpIcon } from '@blueprintjs/core';

export const Message = props => {
  const className = cx('discussion--message', {
    right: props.isMyPartyMessage === true
  });

  const isMyMessageSeen = () => {
    return props.seenDate && props.isMyPartyMessage && props.isLatest;
  };

  return (
    <div className={className}>
      <div className="discussion--message--content">
        <div className="discussion--message--name">{props.messageFrom}</div>
        <p>{props.message}</p>
      </div>
      <time>{formatLocal(props.sendingDate, DATETIME_FORMAT)}</time>
      {isMyMessageSeen() && (
        <div className="discussion--message--seen">
          <BpIcon icon="tick-circle" iconSize={11} />
          <time>Seen {formatLocal(props.seenDate, DATETIME_FORMAT)}</time>
        </div>
      )}
    </div>
  );
};
Message.propTypes = messageShape;
